import axios from 'axios'
import api from '../../constants/api'
import moment from 'moment'
import { eventBus, getAgentPaymentMethodText } from "../../utils";
import id from "bootstrap-vue/esm/mixins/id";
import { assign } from "bootstrap-vue/esm/utils/object";

export default {
  state: {
    ////////////////////////////////////////////////////
    saveSuccess: false, //저장성공
    saveError: null, //저장실패
    registerReqSuccess: false, //등록성공
    registerReqError: null, //등록실패
    runningSaveError: null,
    ////////////////////////////////////////////////////
    registerId: null,
    copyRegisterId: null,
    goodsType: null,
    goodsTypeOption: [
      // {text: '예약', value: 'Booking'},
      { text: '예약필수쿠폰', value: 'BookingCoupon' },
      { text: '모바일쿠폰', value: 'MobileCoupon' },
      // {text: '금액권', value: 'MoneyCoupon'},

    ],
    goodsName: null,
    goodsTag: null,
    intro: null,
    mainImage: null,
    subImages: [],
    hasSalesPeriod: false,
    saleStartDate: null,
    saleEndDate: null,
    expirationDateSetting: 'SetDayCount',
    validDayCount: 60,
    validFromDate: null,
    validToDate: null,
    cancellableTimeValue: 90,
    cancellableTimeSetting: null,
    cancellableTimeSettingOption: [
      { label: '취소불가능', value: 'NonCancellable' },
      { label: '7일 취소가능', value: 'ForDayCountAfterPurchase7' },
      { label: '90일 취소가능', value: 'ForDayCountAfterPurchase90' },
      { label: '직접입력', value: 'ForDayCountAfterPurchase' },
    ],
    storeCodes: [],
    mainOptionId: null,
    options: [],
    options_ageGroupOption: [
      { text: '성인', value: 'Adult' },
      { text: '어린이', value: 'Child' },
      { text: '유아', value: 'Baby' },
    ],
    options_currencyCodeOption: [
      { text: '한화', value: 'KRW' },
      { text: '달러', value: 'USD' },
    ],
    dayOfWeekType: null,
    dayOfWeekTypeOption: [
      { text: '매일', value: 'Everyday' },
      { text: '주중', value: 'Weekday' },
      { text: '주말', value: 'Weekend' },
      { text: '사용자 지정', value: 'Custom' },
    ],
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    hours: [],
    unusableDays: [],
    publisher: null,
    validPeriod: null,
    conditions: null,
    availableStores: null,
    refundTerms: null,
    contactInfo: null,
    limitedMaxNumToUse: true, // 최대이용매수
    maxNumToUse: null, // 최대이용매수
    requiredPreBooking: true, // 사전예약 필수 여부
    preBookingDaysAgo: null, // x일 전까지 사전예약 필수
    useRuleKid: false, // 소인기준
    ruleKidAgeRange: [null, null], //  x세 ~ y세
    parkingGuide: false, // 주차안내
    parkingGuideText: '', // 주차안내 문구
    showOperatingTime: false, // 운영시간노출여부
    showOperatingTimeText: '',// 운영시간노출 문구
    agreementExternalChannelDist: true, // 외부채널배포에 동의
    channelCodes: [], // 배포할외부채널
    tablenjoyExcluded:true,
    excludedChannels: [], // 배포제외할외부채널
    channelCodesOptions: [], //비투비 api리스트


    // 판매정보
    usePolicy:
      "{storeInfos}\n" +
      "{expirationDateSetting}\n" +
      "{limitedMaxNumToUseInfo}" +
      "{requiredPreBookingInfo}\n" +
      "{parkingGuideInfo}" +
      "{operationTimeInfo}" +
      "{kindInfo}",
    usePolicyStr: '',

    basicPolicy: "해당 쿠폰은 테이블엔조이에서 발행되었습니다.\n" +
      "할인율은 {today} 해당 매장의 메뉴판 판매가 기준으로 산정되었습니다. \n" +
      "{purchaseMessage}\n" + //상품 구매 시, 휴대폰 문자메세지로 모바일쿠폰이 발송 됩니다.
      "테이블엔조이에서 판매되는 상품과는 중복사용이 가능 합니다. \n" +
      "단, 타 할인 및 쿠폰, 현장이벤트와 중복은 불가합니다.\n" +
      "부가세 포함가격",
    basicPolicyStr: '',
    cautionPolicy: "공휴일 & 특정일 (발렌타인데이, 어린이날, 크리스마스 이브 등) 및 12월 연말시즌에는\n" +
      "별도의 특선 상품 또는 주말 상품으로 운영될 수 있습니다.\n",
    cautionPolicyStr: '',
    cancellationRefundPolicy: "구매 후 {cancellableTimeValue}일 이내 취소 요청시 , 100% 환불됩니다.\n" +
      "구매 후 {cancellableTimeValue}일 이후 취소 요청 시 , 구매 금액의 90%가 환불 됩니다.\n" +
      "최초 유효기간이 만료된 경우 유효기간 연장을 신청하실수 있습니다.\n" +
      "단, 현재 같은 가격과 구성으로 동일한 상품이 판매되고 있는 경우에만 가능 합니다.\n" +
      "\"최초 유효기간 이란\" 상품구매 시 최초로 부여되는 유효기간( 연장 이후 기간 제외 )\n" +
      "고객센터 문의 (TEL: 1600-3662) - 평일 09:00 ~ 12:00 (주말,공휴일 휴무)" +
      "\n 카카오톡 1:1 채팅 문의 - 평일 09:00 ~ 16:00 (주말,공휴일 휴무 / 점심시간 12:00 ~ 13:00)",
    cancellationRefundPolicyStr: '',
  },
  getters: {
    saveSuccess: state => state.saveSuccess,
    saveError: state => state.saveError,
    registerReqSuccess: state => state.registerReqSuccess,
    registerReqError: state => state.registerReqError,
    registerId: state => state.registerId,
    copyRegisterId: state => state.copyRegisterId,
    goodsType: state => state.goodsType,
    goodsTypeOption: state => state.goodsTypeOption,
    goodsName: state => state.goodsName,
    goodsTag: state => state.goodsTag,
    intro: state => state.intro,
    mainImage: state => state.mainImage,
    subImages: state => state.subImages,
    hasSalesPeriod: state => state.hasSalesPeriod,
    saleStartDate: state => state.saleStartDate,
    saleEndDate: state => state.saleEndDate,
    expirationDateSetting: state => state.expirationDateSetting,
    validDayCount: state => state.validDayCount,
    validFromDate: state => state.validFromDate,
    validToDate: state => state.validToDate,
    cancellableTimeSetting: state => state.cancellableTimeSetting,
    cancellableTimeSettingOption: state => state.cancellableTimeSettingOption,
    cancellableTimeValue: state => state.cancellableTimeValue,
    storeCodes: state => state.storeCodes,
    mainOptionId: state => state.mainOptionId,
    options: state => state.options,
    options_ageGroupOption: state => state.options_ageGroupOption,
    options_currencyCodeOption: state => state.options_currencyCodeOption,
    dayOfWeekType: state => state.dayOfWeekType,
    dayOfWeekTypeOption: state => state.dayOfWeekTypeOption,
    monday: state => state.monday,
    tuesday: state => state.tuesday,
    wednesday: state => state.wednesday,
    thursday: state => state.thursday,
    friday: state => state.friday,
    saturday: state => state.saturday,
    sunday: state => state.sunday,
    hours: state => state.hours,
    unusableDays: state => state.unusableDays,
    publisher: state => state.publisher,
    validPeriod: state => state.validPeriod,
    conditions: state => state.conditions,
    availableStores: state => state.availableStores,
    refundTerms: state => state.refundTerms,
    contactInfo: state => state.contactInfo,

    // 판매정보
    limitedMaxNumToUse: state => state.limitedMaxNumToUse,
    maxNumToUse: state => state.maxNumToUse,
    requiredPreBooking: state => state.requiredPreBooking,
    preBookingDaysAgo: state => state.preBookingDaysAgo,
    useRuleKid: state => state.useRuleKid,
    ruleKidAgeRange: state => state.ruleKidAgeRange,
    parkingGuide: state => state.parkingGuide,
    parkingGuideText: state => state.parkingGuideText,
    showOperatingTime: state => state.showOperatingTime,
    showOperatingTimeText: state => state.showOperatingTimeText,
    agreementExternalChannelDist: state => state.agreementExternalChannelDist,
    channelCodes: state => state.channelCodes,
    tablenjoyExcluded: state => state.tablenjoyExcluded,
    excludedChannels: state => state.excludedChannels,
    channelCodesOptions: state => state.channelCodesOptions,

    usePolicy: state => state.usePolicy,
    basicPolicy: state => state.basicPolicy,
    cautionPolicy: state => state.cautionPolicy,
    cancellationRefundPolicy: state => state.cancellationRefundPolicy,
    usePolicyStr: state => state.usePolicyStr,
    basicPolicyStr: state => state.basicPolicyStr,
    cautionPolicyStr: state => state.cautionPolicyStr,
    cancellationRefundPolicyStr: state => state.cancellationRefundPolicyStr,

  },


  mutations: {
    setSaveSuccess(state, payload) {
      state.saveSuccess = payload
    },
    setSaveError(state, payload) {
      state.saveError = payload
    },
    setRegisterReqSuccess(state, payload) {
      state.registerReqSuccess = payload
    },
    setRegisterReqError(state, payload) {
      state.registerReqError = payload
    },

    setRegisterId(state, payload) {
      state.registerId = payload
    },
    setCopyRegisterId(state, e) {
      state.copyRegisterId = e
    },
    setGoodsType(state, e) {
      state.goodsType = e
    },
    setGoodsTypeOption(state, e) {
      state.goodsTypeOption = e
    },
    setGoodsName(state, e) {
      state.goodsName = e
    },
    setGoodsTag(state, e) {
      state.goodsTag = e
    },
    setIntro(state, e) {
      state.intro = e
    },
    setMainImage(state, e) {
      state.mainImage = e
    },
    setSubImages(state, e) {
      state.subImages = e
    },
    setHasSalesPeriod(state, e) {
      state.hasSalesPeriod = e
    },
    setSaleStartDate(state, e) {
      state.saleStartDate = e
    },
    setSaleEndDate(state, e) {
      state.saleEndDate = e
    },
    setExpirationDateSetting(state, e) {
      state.expirationDateSetting = e
    },
    setValidDayCount(state, e) {
      state.validDayCount = e
    },
    setValidFromDate(state, e) {
      state.validFromDate = e
    },
    setValidToDate(state, e) {
      state.validToDate = e
    },
    setCancellableTimeSetting(state, e) {
      state.cancellableTimeSetting = e
    },
    setCancellableTimeSettingOption(state, e) {
      state.cancellableTimeSettingOption = e
    },
    setCancellableTimeValue(state, e) {
      state.cancellableTimeValue = e
    },
    setStoreCodes(state, e) {
      state.storeCodes = e
    },

    setMainOptionId(state, e) {
      state.mainOptionId = e
    },
    setOptions(state, e) {
      state.options = e
    },
    setOptions_ageGroupOption(state, e) {
      state.options_ageGroupOption = e
    },
    setOptions_currencyCodeOption(state, e) {
      state.options_currencyCodeOption = e
    },
    setDayOfWeekType(state, e) {
      state.dayOfWeekType = e
    },
    setDayOfWeekTypeOption(state, e) {
      state.dayOfWeekTypeOption = e
    },
    setMonday(state, e) {
      state.monday = e
    },
    setTuesday(state, e) {
      state.tuesday = e
    },
    setWednesday(state, e) {
      state.wednesday = e
    },
    setThursday(state, e) {
      state.thursday = e
    },
    setFriday(state, e) {
      state.friday = e
    },
    setSaturday(state, e) {
      state.saturday = e
    },
    setSunday(state, e) {
      state.sunday = e
    },
    setHours(state, e) {
      state.hours = e
    },
    setUnusableDays(state, e) {
      state.unusableDays = e
    },
    setPublisher(state, e) {
      state.publisher = e
    },
    setValidPeriod(state, e) {
      state.validPeriod = e
    },
    setConditions(state, e) {
      state.conditions = e
    },
    setAvailableStores(state, e) {
      state.availableStores = e
    },
    setRefundTerms(state, e) {
      state.refundTerms = e
    },
    setContactInfo(state, e) {
      state.contactInfo = e
    },

    //판매정보
    setLimitedMaxNumToUse(state, e) {
      state.limitedMaxNumToUse = e
    },
    setMaxNumToUse(state, e) {
      state.maxNumToUse = e
    },
    setRequiredPreBooking(state, e) {
      state.requiredPreBooking = e
    },
    setPreBookingDaysAgo(state, e) {
      state.preBookingDaysAgo = e
    },
    setUseRuleKid(state, e) {
      state.useRuleKid = e
    },
    setRuleKidAgeRange(state, e) {
      state.ruleKidAgeRange = e
    },
    setParkingGuide(state, e) {
      state.parkingGuide = e
    },
    setParkingGuideText(state, e) {
      state.parkingGuideText = e
    },
    setShowOperatingTime(state, e) {
      state.showOperatingTime = e
    },
    setShowOperatingTimeText(state, e) {
      state.showOperatingTimeText = e
    },
    setAgreementExternalChannelDist(state, e) {
      state.agreementExternalChannelDist = e
    },
    setChannelCodes(state, e) {
      state.channelCodes = e
    },
    setTablenjoyExcluded(state,e) {
      state.tablenjoyExcluded = e
    },
    setExcludedChannels(state, e) {
      state.excludedChannels = e
    },
    setChannelCodesOptions(state, e) {
      state.channelCodesOptions = e
    },
    setUsePolicy(state, e) {
      state.usePolicy = e
    },
    setBasicPolicy(state, e) {
      state.basicPolicy = e
    },
    setCautionPolicy(state, e) {
      state.cautionPolicy = e
    },
    setCancellationRefundPolicy(state, e) {
      state.cancellationRefundPolicy = e
    },
    setUsePolicyStr(state, e) {
      state.usePolicyStr = e
    },
    setBasicPolicyStr(state, e) {
      state.basicPolicyStr = e
    },
    setCautionPolicyStr(state, e) {
      state.cautionPolicyStr = e
    },
    setCancellationRefundPolicyStr(state, e) {
      state.cancellationRefundPolicyStr = e
    },

  },

  actions: {

    goodsId({ commit }, payload) {
      commit('setRegisterId', payload.registerId)
    },


    /** ***************************************************************************************************************/
    //초기화
    async goodsReset({ commit }) {
      commit('setGoodsType', null)
      commit('setSaveSuccess', false)
      commit('setSaveError', null)
      commit('setRegisterReqSuccess', false)
      commit('setRegisterReqError', null)
      commit('setGoodsName', null)
      commit('setIntro', null)
      commit('setMainImage', null)
      commit('setSubImages', [])
      commit('setStoreCodes', [])
      commit('setHasSalesPeriod', false)
      commit('setSaleStartDate', null)
      commit('setSaleEndDate', null)
      commit('setExpirationDateSetting', 'SetDayCount')
      commit('setValidDayCount', 60)
      commit('setValidFromDate', null)
      commit('setValidToDate', null)
      commit('setCancellableTimeValue', 90)
      commit('setDayOfWeekType', "Everyday")
      commit('setMonday', false)
      commit('setTuesday', false)
      commit('setWednesday', false)
      commit('setThursday', false)
      commit('setFriday', false)
      commit('setSaturday', false)
      commit('setSunday', false)
      commit('setOptions', [])
      commit('setHours', [])
      commit('setUnusableDays', [])
      commit('setAgreementExternalChannelDist', true)
      commit('setChannelCodes', [])
      commit('tablenjoyExcluded', true)
      commit('setExcludedChannels', [])
      commit('setBasicPolicyStr', '')
      commit('setCautionPolicyStr', '')
      commit('setCancellationRefundPolicyStr', '')
      commit('setUsePolicyStr', '')

      commit('setLimitedMaxNumToUse', true)
      commit('setMaxNumToUse', null)
      commit('setRequiredPreBooking', true)
      commit('setPreBookingDaysAgo', null)
      commit('setUseRuleKid', false)
      commit('setRuleKidAgeRange', [null, null])
      commit('setParkingGuide', false)
      commit('setParkingGuideText', '')
      commit('setShowOperatingTime', false)
      commit('setShowOperatingTimeText', '')


    },


    /** ***************************************************************************************************************/
    //상품 조회
    goodsInfo({ commit, getters }, payload) {
      const url = [
        api.changeAPI(payload.siteName, api.basicURL + api.goods.intro),                        // 0상품 소개 정보 조회
        api.changeAPI(payload.siteName, api.basicURL + api.goods.optionsAndUsableHours),            // 1상품 옵션 및 이용 가능 시간 조회
        api.changeAPI(payload.siteName, api.basicURL + api.goods.condition),                    // 2상품 사용 조건 조회
        api.changeAPI(payload.siteName, api.basicURL + api.goods.channels),                     // 3상품 B2B 채널 배포 설정 조회
        api.changeAPI(payload.siteName, api.basicURL + api.goods.usage),                        // 4상품 사용 정보 조회
        api.changeAPI(payload.siteName, api.basicURL + api.goods.notice)                        // 5상품 고시 정보 및 기타 설정 조회
      ]


      const params = { goodsId: getters.registerId }


      const headers = { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      const aRequest = []

      url.forEach((o, i) => {
        aRequest.push(axios.get(url[i], { params: params, headers }))
      })

      axios.all(aRequest).then(axios.spread((...responses) => {

        for (let i = 0; i < 6; i++) {
          // console.log(i, responses[i]);
        }

        //상품정보
        commit('setGoodsType', responses[0].data.data.goodsType)
        commit('setGoodsName', responses[0].data.data.introduction.goodsName)
        commit('setGoodsTag', responses[0].data.data.introduction.goodsTag)
        commit('setIntro', responses[0].data.data.introduction.intro)
        commit('setMainImage', responses[0].data.data.introduction.mainImage)

        const subArr = []
        responses[0].data.data.introduction.subImages.forEach(function (value, index) {
          subArr.push({
            description: value.description,
            displayOrder: value.displayOrder,
            id: index++,
            images: value.images,
            title: value.title
          })
        })
        commit('setSubImages', subArr)


        //옵션/가격

        // if(getters.goodsType == "Booking" || getters.goodsType == " BookingCoupon") {
        commit('setDayOfWeekType', responses[1].data.data.usableHour.dayOfWeekType)
        if (responses[1].data.data.usableHour.dayOfWeekType == "Custom") {
          commit('setMonday', responses[1].data.data.usableHour.monday)
          commit('setTuesday', responses[1].data.data.usableHour.tuesday)
          commit('setWednesday', responses[1].data.data.usableHour.wednesday)
          commit('setThursday', responses[1].data.data.usableHour.thursday)
          commit('setFriday', responses[1].data.data.usableHour.friday)
          commit('setSaturday', responses[1].data.data.usableHour.saturday)
          commit('setSunday', responses[1].data.data.usableHour.sunday)
        }

        let hourArr = []
        const hours = responses[1].data.data.usableHour.hours;
        hours.forEach(function (value, index) {
          // console.log(value);
          hourArr.push({
            id: index,
            hour: 'h' + value.substr(0, 2),
            minute: 'm' + value.substr(3, 2)
          })
        })
        commit('setHours', hourArr)
        // }
        commit('setUnusableDays', responses[1].data.data.usableHour.unusableDays)

        const options = []
        const mainOptionId = responses[1].data.data.goodsOption.mainOptionId
        responses[1].data.data.goodsOption.options.forEach(function (value, index) {
          const option = value
          Object.assign(option, { newOption: false, mainOption: value.optionId == mainOptionId ? true : false })
          options.push(option)
        })
        options.sort(function (a, b) {
          return a.displayOrder < b.displayOrder ? -1 : a.displayOrder < b.displayOrder ? 1 : 0;
        });
        commit('setOptions', options)
        commit('setMainOptionId', responses[1].data.data.goodsOption.mainOptionId)


        const saleStartDate = responses[2].data.data.timeCondition.saleStartDate
        const saleEndDate = responses[2].data.data.timeCondition.saleEndDate
        const availableFromDate = responses[2].data.data.timeCondition.availableFromDate
        const availableToDate = responses[2].data.data.timeCondition.availableToDate

        //사용조건
        commit('setStoreCodes', responses[2].data.data.serviceArea.brands[0].storeCodes)
        commit('setHasSalesPeriod', responses[2].data.data.timeCondition.hasSalesPeriod)
        commit('setSaleStartDate', saleStartDate == null ? null : new Date(saleStartDate))
        commit('setSaleEndDate', saleEndDate == null ? null : new Date(saleEndDate))
        commit('setExpirationDateSetting', responses[2].data.data.timeCondition.availableDateSetting)
        commit('setValidDayCount', responses[2].data.data.timeCondition.availableDayCount)
        commit('setValidFromDate', availableFromDate == null ? null : new Date(availableFromDate))
        commit('setValidToDate', availableToDate == null ? null : new Date(availableToDate))
        commit('setCancellableTimeValue', responses[2].data.data.timeCondition.itemCancellableDayCount)

        //판매채널
        commit('setAgreementExternalChannelDist', responses[3].data.data.channelSalesAgreement)
        commit('setExcludedChannels', responses[3].data.data.excludedChannels)
        commit('setTablenjoyExcluded', responses[3].data.data.tablenjoyExcluded)


        //판매정보
        if (responses[4].data.code == "OK") {
          //사용정보
          //사용장소, 유효기간, 매수제한,
          commit('setBasicPolicyStr', responses[4].data.data.usage.baseInfo)
          //기본정보
          commit('setCautionPolicyStr', responses[4].data.data.usage.notes)
          //유의사항
          commit('setCancellationRefundPolicyStr', responses[4].data.data.usage.returnsAndRefunds)
          //취소/환불 규정
          commit('setUsePolicyStr', responses[4].data.data.usage.useInfo)
        }

      }))
        .catch(error => {
          alert(error.response.data.message);
        })


    },


    /** ***************************************************************************************************************/
    //등록대기 상품조회
    async reqGoodsInfo({ commit, getters }, payload) {


      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.info)
      const params = { registerId: getters.registerId }

      await axios.get(reqURL, {
        params: params,
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {


        const goodsInfo = res.data.data.goodsInfo

        commit('setGoodsType', goodsInfo.goodsType)
        commit('setGoodsName', goodsInfo.introduction.goodsName)
        commit('setGoodsTag', goodsInfo.introduction.goodsTag)
        commit('setIntro', goodsInfo.introduction.intro)
        commit('setMainImage', goodsInfo.introduction.mainImage)

        const subImgArr = []
        res.data.data.goodsInfo.introduction.subImages.forEach(function (value, index) {
          subImgArr.push({
            description: value.description,
            displayOrder: value.displayOrder,
            id: index++,
            images: value.images,
            title: value.title
          })
        })
        commit('setSubImages', subImgArr)


        const saleStartDate = goodsInfo.serviceCondition.timeCondition.saleStartDate
        const saleEndDate = goodsInfo.serviceCondition.timeCondition.saleEndDate

        const availableFromDate = goodsInfo.serviceCondition.timeCondition.availableFromDate
        const availableToDate = goodsInfo.serviceCondition.timeCondition.availableToDate


        // //사용조건 step3
        commit('setStoreCodes', goodsInfo.serviceCondition.serviceArea.brands[0].storeCodes)
        commit('setHasSalesPeriod', goodsInfo.serviceCondition.timeCondition.hasSalesPeriod)
        commit('setSaleStartDate', saleStartDate == null ? null : new Date(saleStartDate))
        commit('setSaleEndDate', saleEndDate == null ? null : new Date(saleEndDate))
        commit('setExpirationDateSetting', goodsInfo.serviceCondition.timeCondition.availableDateSetting)
        commit('setValidDayCount', goodsInfo.serviceCondition.timeCondition.availableDayCount)
        commit('setValidFromDate', availableFromDate == null ? null : new Date(availableFromDate))
        commit('setValidToDate', availableToDate == null ? null : new Date(availableToDate))
        commit('setCancellableTimeValue', goodsInfo.serviceCondition.timeCondition.itemCancellableDayCount)


        //옵션/가격 step4
        if (getters.goodsType != 'MobileCoupon') {
          commit('setDayOfWeekType', goodsInfo.usableHour.dayOfWeekType)
          commit('setMonday', goodsInfo.usableHour.monday)
          commit('setTuesday', goodsInfo.usableHour.tuesday)
          commit('setWednesday', goodsInfo.usableHour.wednesday)
          commit('setThursday', goodsInfo.usableHour.thursday)
          commit('setFriday', goodsInfo.usableHour.friday)
          commit('setSaturday', goodsInfo.usableHour.saturday)
          commit('setSunday', goodsInfo.usableHour.sunday)

          const arr = []
          goodsInfo.usableHour.hours.forEach(function (value, index) {
            arr.push({
              id: index,
              hour: 'h' + value.substr(0, 2),
              minute: 'm' + value.substr(3, 2)
            })
          })
          commit('setHours', arr)

          commit('setUnusableDays', goodsInfo.usableHour.unusableDays)
        }
        commit('setOptions', goodsInfo.goodsOption.options)


        commit('setAgreementExternalChannelDist', goodsInfo.b2bChannel.channelSalesAgreement)
        commit('setTablenjoyExcluded', goodsInfo.b2bChannel.tablenjoyExcluded)
        if (goodsInfo.b2bChannel.channelSalesAgreement) {
          commit('setExcludedChannels', goodsInfo.b2bChannel.excludedChannels)

        }


        // // 판매정보
        commit('setBasicPolicyStr', goodsInfo.usage.baseInfo)
        commit('setCautionPolicyStr', goodsInfo.usage.notes)
        commit('setCancellationRefundPolicyStr', goodsInfo.usage.returnsAndRefunds)
        commit('setUsePolicyStr', goodsInfo.usage.useInfo)


      }).catch(err => {
      })


    },


    /** ***************************************************************************************************************/
    //판매정보 자동생성
    async goodsShowInfo({ commit, getters }, payload) {


      /** 사용정보 :
       * 사용장소, 유효기간, 최대이용매수, 사전예약필수, 소인기준, 주차안내, 운영시간,
       * 예약권이용안내, 온라인예약이용방법(예약권)
       */

      let usePolicyStr = getters.usePolicy


      if (getters.goodsType != "Booking") {
        //사용장소
        let storeNames = []
        const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.shop.brandStoreCode)
        await axios.get(reqURL, {
          headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
        }).then(res => {
          // ;
          if (res.data.code === "OK") {
            getters.storeCodes.forEach(function (value, index) {
              const storeCode = value
              res.data.data.forEach(function (v, i) {
                if (v.storeCode == storeCode) {
                  storeNames.push(v.storeName)
                }
              })
            })
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
        let BookingText = '';
        if (getters.goodsType == "BookingCoupon") {
          BookingText = '*매장에 문의사항이 있는 경우 테이블엔조이에서 구매했다고 말씀 부탁드립니다.\n\n';
        }
        usePolicyStr = usePolicyStr.replace('{storeInfos}', BookingText + '사용장소 : ' + storeNames)


        //유효기간
        if (getters.expirationDateSetting == 'SetFromToDate') {
          const str = '유효기간 : ' + moment(getters.validFromDate).format('YYYY-MM-DD') +
            ' ~ ' + moment(getters.validToDate).format('YYYY-MM-DD')
          usePolicyStr = usePolicyStr.replace('{expirationDateSetting}', str)

        } else { //SetDayCount
          const str = '유효기간 : 구매후 ' + getters.validDayCount + '일'
          usePolicyStr = usePolicyStr.replace('{expirationDateSetting}', str)
        }


        //사전예약필수
        if (!getters.requiredPreBooking) {
          const str = '반드시 ' + getters.preBookingDaysAgo + '일전 사전 예약 후 이용 가능 합니다.'
          usePolicyStr = usePolicyStr.replace('{requiredPreBookingInfo}', str)
        } else {
          const str = '원할한 이용을 위해 예약을 권장 합니다.\n예약은 매장에 전화예약 부탁드립니다.\n(매장에 이용문의 시 테이블엔조이에서 구매했다고 말씀부탁드립니다.)'
          usePolicyStr = usePolicyStr.replace('{requiredPreBookingInfo}', str)
        }
      } else {
        usePolicyStr = usePolicyStr.replace('{storeInfos}\n', '')
        usePolicyStr = usePolicyStr.replace('{expirationDateSetting}\n', '')
        usePolicyStr = usePolicyStr.replace('{requiredPreBookingInfo}\n', '')
      }


      //최대이용매수
      if (!getters.limitedMaxNumToUse) {
        const str = '해당상품은 일행당 ' + getters.maxNumToUse + '매 사용 가능합니다.'
        usePolicyStr = usePolicyStr.replace('{limitedMaxNumToUseInfo}', str)
      } else {
        const str = '해당상품은 매수 제한없이 사용 가능 합니다.'
        usePolicyStr = usePolicyStr.replace('{limitedMaxNumToUseInfo}', str)
      }


      //소인기준
      if (getters.useRuleKid) {
        let str = '소인기준 : '
        // if((getters.ruleKidAgeRange[0] != null && getters.ruleKidAgeRange[0] != '')
        //   && (getters.ruleKidAgeRange[1] != null && getters.ruleKidAgeRange[1] != '')) {
        //   str += getters.ruleKidAgeRange[0] + '세 ~ ' + getters.ruleKidAgeRange[1] + '세'
        // }
        if (getters.ruleKidAgeRange[0] != null && getters.ruleKidAgeRange[0] != '') {
          str += getters.ruleKidAgeRange[0]
        }

        usePolicyStr = usePolicyStr.replace('{kindInfo}', str)
      } else {
        usePolicyStr = usePolicyStr.replace('{kindInfo}', '')
      }

      //주차안내
      if (getters.parkingGuide) {
        const str = '주차안내 : ' + getters.parkingGuideText
        usePolicyStr = usePolicyStr.replace('{parkingGuideInfo}', str)
      } else {
        const str = '주차안내 : 주차불가'
        usePolicyStr = usePolicyStr.replace('{parkingGuideInfo}', str)
      }


      //운영시간
      if (getters.showOperatingTime) {
        const str = '운영시간 : ' + getters.showOperatingTimeText + '\n'
        usePolicyStr = usePolicyStr.replace('{operationTimeInfo}', str)
      } else {
        usePolicyStr = usePolicyStr.replace('{operationTimeInfo}', '')
      }

      //예약권 : 예약권 이용안내, 온라인예약 이용방법
      if (getters.goodsType == "BookingCoupon") {

        usePolicyStr += '\n\n▶ 예약필수쿠폰 이용안내\n' +
          '해당 상품은 온라인 예약이 필수인 예약 필수 상품입니다.\n' +
          '예약없이 방문 시, 테이블 및 메뉴 등 사전 준비되지 않아 이용 불가 합니다.\n' +
          '상품을 구매하시면 카카오 알림톡 또는 문자메세지로 쿠폰이 전송 됩니다.  \n'+
          '쿠폰에 있는 “날짜 지정하기＂를 통해 온라인 예약을 진행해 주세요.\n'+
          '예약완료 알림문자 수신 후 매장에 방문하셔야 합니다.\n'+
          // '반드시 쿠폰 구매 시 발송되는 모바일쿠폰을 통해 온라인 예약을 진행해 주세요.\n' +
          // '예약 확정 문자 수신 후 매장에 방문하셔야 합니다.\n' +
          // '예약 및 예약 확정 문자 없이 방문 시에는 이용이 불가 합니다.\n' +
          '자세한 이용 문의는 고객센터로 연락 주세요. \n'+
          '유선문의 : 1600-3662 / 09:00~12:00\n' +
          '카카오톡 1:1 문의하기 : @테이블엔조이 검색 / 09:00 ~ 16:00\n'+
          '\n' +
          '▶ 온라인 예약 이용방법\n' +
          '1. 발송되는 카카오 알림톡 내 “날짜 지정하기＂를 통하여 예약 페이지로 이동 합니다.\n'+
          '(e쿠폰함의 경우 추가안내링크에 있는 URL을 통해 예약페이지로 이동합니다. )\n' +
          '2. 사용할 쿠폰을 선택 후 이용하실 날짜와 시간을 선택합니다.\n' +
          '3. 예약 신청 후 “예약완료 알림문자＂를 수신합니다. (매장에 따라 약 1일 소요)\n' +
          '4. 매장 방문 후 “예약완료 알림문자＂를 보여주시고, 고객님의 성함을 말씀해주세요.\n' +
          '※ 예약을 하지 않거나 “예약완료 알림문자” 없이 방문 시에는 이용이 불가 합니다.'
      }

      commit('setUsePolicyStr', usePolicyStr)


      /** 기본정보 : 할인율 */
      let basicPolicyStr = getters.basicPolicy
      basicPolicyStr = basicPolicyStr.replace('{today}', moment(new Date()).format('YYYY-MM-DD'))

      if (getters.goodsType != 'Booking') {
        basicPolicyStr = basicPolicyStr.replace('{purchaseMessage}', '상품 구매 시, 카카오 알림톡 또는 문자로 모바일 쿠폰이 발송 됩니다.')
      } else {
        basicPolicyStr = basicPolicyStr.replace('{purchaseMessage}\n', '')

      }
      commit('setBasicPolicyStr', basicPolicyStr)

      /** 유의사항 */


      let cautionPolicyStr = getters.cautionPolicy

      if (getters.goodsType != 'Booking') {
        cautionPolicyStr += "반드시 구매전 매장으로 문의후 이용해 주세요.\n" +
          "해당 쿠폰은 제 3자에게로 매매가 허용되지 않습니다. \n" +
          "개인간 거래를 통해 취득한 쿠폰은 사용이 제한될 수 있습니다.\n" +
          "쿠폰의 내용을 추가 또는 삭제하여 재배포한 경우, 해당 쿠폰의 사용이 제한될 수 있습니다.\n" +
          "유효기간이 만료된 쿠폰은 사용하실 수 없습니다."
      }

      commit('setCautionPolicyStr', cautionPolicyStr)


      /** 취소/환불 규정 : 취소기한 */
      let cancellationRefundPolicyStr = getters.cancellationRefundPolicy
      if (getters.goodsType == "Booking") {
        cancellationRefundPolicyStr = '이용 1일 전 취소 : 100% 환불 됩니다.\n이용 당일 취소 : 환불 불가 합니다.'
      } else {
        cancellationRefundPolicyStr = cancellationRefundPolicyStr.replaceAll('{cancellableTimeValue}', getters.cancellableTimeValue)


        if (getters.goodsType == "BookingCoupon") {
          cancellationRefundPolicyStr += '\n\n▶ 예약 후 취소/환불 안내\n' +
            '예약 필수 상품으로 예약 후에는 별도의 취소 규정이 적용됩니다.\n' +
            '이용 1일 전 취소 : 100% 환불 됩니다.\n' +
            '이용 당일 취소 : 전액 환불 불가 합니다.'
        }
      }

      commit('setCancellationRefundPolicyStr', cancellationRefundPolicyStr)

    }
    ,

    /** ***************************************************************************************************************/
    //판매채널조회
    async goodsChannelCodesOptions({ commit, getters }, payload) {

      const params = { manageType: 'GoodsSalesBrand' }
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.b2b.channelList)
      await axios.get(reqURL, {
        params: params,
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      })
        .then(res => {

          const channelCodesOptions = []
          res.data.data.channels.forEach(v => {
            channelCodesOptions.push({ text: v.channelName, value: v.channelCode })
          })
          commit('setChannelCodesOptions', channelCodesOptions)

          // var channelCodesOptions = getters.channelCodesOptions
          // var channelCodes =  getters.channelCodes
          //
          // const excludedChannels = []
          // channelCodesOptions.forEach(v => {
          //   let flag = true
          //   channelCodes.forEach(vv => {
          //     console.log(v.value, vv);
          //     if(vv == v.value) {
          //       flag = false
          //     }
          //   })
          //   if(flag) {
          //     console.log(v);
          //     excludedChannels.push(v.value)
          //   }
          // })
          // commit("setExcludedChannels", excludedChannels)


          const channelCodes = []
          if (payload.modeFlag) { //신규등록, 전체체크

            const channels = res.data.data.channels
            const excludedChannels = getters.excludedChannels

            channels.forEach(v => {
              let flag = true
              excludedChannels.forEach(vv => {
                if (v.channelCode == vv) {
                  flag = false
                }
              })

              if (flag) {
                channelCodes.push(v.channelCode)
              }
            })


          } else {
            res.data.data.channels.forEach(v => {
              channelCodes.push(v.channelCode)
            })
          }

          commit('setChannelCodes', channelCodes)


        })
        .catch(err => {
        })
    },


    /** ***************************************************************************************************************/
    // 등록대기상품 생성
    // 등록 대기 상품 정보 생성
    reqGoodsCreate({ commit, getters }, payload) {

      let mainImg = null
      if (getters.mainImage != null) {
        mainImg = {
          url: getters.mainImage.url,
          width: getters.mainImage.width,
          height: getters.mainImage.height
        }
      }

      let displayOrder = 1
      let subImg = null
      if (getters.subImages.length != 0) {
        subImg = []
        getters.subImages.forEach(function (value, index) {
          subImg.push({
            title: value.title,
            description: value.description,
            displayOrder: displayOrder++,
            images: value.images
          })
        })
      }

      displayOrder = 1
      let options = null
      if (getters.options.length != 0) {
        options = []
        getters.options.forEach(function (value, index) {
          let option = {
            optionName: value.optionName,
            displayOrder: displayOrder++,
            listPrice: Number(value.listPrice.replace(",", "")),
            salePrice: Number(value.salePrice.replace(",", "")),
            deliveryPrice: null,
            inventory: Number(value.inventory),
            // ageGroup: value.ageGroup,
            // headcount: Number(value.headcount),
            currencyCode: value.currencyCode,
            mainOption: value.mainOption
          }

          if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {
            Object.assign(option, { ageGroup: value.ageGroup, headcount: Number(value.headcount) })
          }


          options.push(option)
        })
      }


      let serviceCondition = {
        serviceArea: {
          brands: [{
            brandCode: null,
            storeCodes: getters.storeCodes
          }]
        },
        timeCondition: {
          hasSalesPeriod: getters.hasSalesPeriod,
          saleStartDate: getters.hasSalesPeriod ? moment(getters.saleStartDate).format('YYYY-MM-DD') : null,
          saleEndDate: getters.hasSalesPeriod ? moment(getters.saleEndDate).format('YYYY-MM-DD') : null,
          availableDateSetting: getters.expirationDateSetting,
          availableDayCount: getters.expirationDateSetting == 'SetDayCount' ? getters.validDayCount : null,
          availableFromDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validFromDate).format('YYYY-MM-DD') : null,
          availableToDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validToDate).format('YYYY-MM-DD') : null
        }
      }

      if (getters.goodsType != "Booking") { //모바일쿠폰/금액권/예약권 상품
        Object.assign(serviceCondition.timeCondition, { itemCancellableDayCount: getters.cancellableTimeValue })

      }


      let hours = []
      let unusableDays = []
      if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {
        if (getters.hours.length > 0) {
          getters.hours.forEach(function (value, index) {
            if (value.hour !== null) {
              hours.push(value.hour.substr(1, 2) + ':' + value.minute.substr(1, 2) + ':00')
            }
          })
        }
        if (getters.unusableDays.length > 0) {
          getters.unusableDays.forEach(function (value, index) {
            unusableDays.push(value)
          })
        }
      }

      let usableHour = {
        dayOfWeekType: getters.dayOfWeekType,
        monday: getters.monday,
        tuesday: getters.tuesday,
        wednesday: getters.wednesday,
        thursday: getters.thursday,
        friday: getters.friday,
        saturday: getters.saturday,
        sunday: getters.sunday,
        hours: hours.length == 0 ? null : hours,
        unusableDays: unusableDays.length == 0 ? null : unusableDays,
      }

      const params = {
        goodsType: getters.goodsType,
        introduction: {
          goodsName: getters.goodsName,
          goodsTag: getters.goodsTag,
          intro: getters.intro,
          mainImage: mainImg,
          subImages: subImg
        },
        serviceCondition: serviceCondition,
        goodsOption: {
          hasOwnDeliveryPrice: false,
          options: options
        },
        usableHour: usableHour,
        b2bChannel: {
          channelSalesAgreement: getters.agreementExternalChannelDist,
          excludedChannels: getters.excludedChannels,
          tablenjoyExcluded: getters.tablenjoyExcluded,
        },
        usage: {
          useInfo: getters.usePolicyStr,
          baseInfo: getters.basicPolicyStr,
          notes: getters.cautionPolicyStr,
          returnsAndRefunds: getters.cancellationRefundPolicy.replaceAll('{cancellableTimeValue}', getters.cancellableTimeValue)
        }
      }
      commit('setCancellationRefundPolicyStr', getters.cancellationRefundPolicy.replaceAll('{cancellableTimeValue}', getters.cancellableTimeValue))

      eventBus.$emit('bus-event', true);
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.create)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        eventBus.$emit('bus-event', false);
        //
        if (res.data.code == "OK") {
          commit("setSaveSuccess", true)
        } else {
          commit("setSaveError", err)
        }
      }).catch(err => {
        eventBus.$emit('bus-event', false);
        commit("setSaveError", err)

      })


    }
    ,

    /** ***************************************************************************************************************/
    // 등록대기상품 임시저장
    // 등록 대기 상품 정보 수정
    reqGoodsUpdate({ commit, getters }, payload) {

      let mainImg = null
      if (getters.mainImage != null) {
        mainImg = {
          "url": getters.mainImage.url,
          "width": getters.mainImage.width,
          "height": getters.mainImage.height
        }
      }


      let displayOrder = 1
      let subImg = null
      if (getters.subImages.length != 0) {
        subImg = []
        getters.subImages.forEach(function (value, index) {
          subImg.push({
            "title": value.title,
            "description": value.description,
            "displayOrder": displayOrder++,
            "images": value.images
          })
        })
      }

      displayOrder = 1
      let options = null
      if (getters.options.length != 0) {
        options = []
        getters.options.forEach(function (value, index) {
          let option =
          {
            optionName: value.optionName,
            displayOrder: displayOrder++,
            listPrice: Number(value.listPrice.replace(",", "")),
            salePrice: Number(value.salePrice.replace(",", "")),
            deliveryPrice: null,
            inventory: Number(value.inventory),
            // ageGroup: value.ageGroup,
            // headcount: Number(value.headcount),
            currencyCode: value.currencyCode,
            mainOption: value.mainOption
          }

          if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {
            Object.assign(option, { ageGroup: value.ageGroup, headcount: Number(value.headcount) })
          }
          options.push(option)
        })
      }


      let serviceCondition = {
        serviceArea: {
          brands: [{
            brandCode: null,
            storeCodes: getters.storeCodes
          }]
        },
        timeCondition: {
          hasSalesPeriod: getters.hasSalesPeriod,
          saleStartDate: getters.hasSalesPeriod ? moment(getters.saleStartDate).format('YYYY-MM-DD') : null,
          saleEndDate: getters.hasSalesPeriod ? moment(getters.saleEndDate).format('YYYY-MM-DD') : null,
          availableDateSetting: getters.expirationDateSetting,
          availableDayCount: getters.expirationDateSetting == 'SetDayCount' ? getters.validDayCount : null,
          availableFromDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validFromDate).format('YYYY-MM-DD') : null,
          availableToDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validToDate).format('YYYY-MM-DD') : null
        }
      }

      if (getters.goodsType != "Booking") { //모바일쿠폰/금액권/예약권 상품
        console.log(Object);
        Object.assign(serviceCondition.timeCondition, { itemCancellableDayCount: getters.cancellableTimeValue })

      }

      let hours = []
      let unusableDays = []
      if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {
        if (getters.hours.length > 0) {
          getters.hours.forEach(function (value, index) {
            if (value.hour !== null) {
              hours.push(value.hour.substr(1, 2) + ':' + value.minute.substr(1, 2) + ':00')
            }
          })
        }
        if (getters.unusableDays.length > 0) {
          getters.unusableDays.forEach(function (value, index) {
            unusableDays.push(value)
          })
        }
      }

      let usableHour = {
        dayOfWeekType: getters.dayOfWeekType,
        monday: getters.monday,
        tuesday: getters.tuesday,
        wednesday: getters.wednesday,
        thursday: getters.thursday,
        friday: getters.friday,
        saturday: getters.saturday,
        sunday: getters.sunday,
        hours: hours.length == 0 ? null : hours,
        unusableDays: unusableDays.length == 0 ? null : unusableDays,
      }


      var channelCodesOptions = getters.channelCodesOptions
      var channelCodes = getters.channelCodes

      const excludedChannels = []
      channelCodesOptions.forEach(v => {
        let flag = true
        channelCodes.forEach(vv => {
          if (vv == v.value) {
            flag = false
          }
        })
        if (flag) {
          excludedChannels.push(v.value)
        }
      })
      commit("setExcludedChannels", excludedChannels)

      const params = {
        registerId: getters.registerId,
        goodsType: getters.goodsType,
        introduction: {
          goodsName: getters.goodsName,
          goodsTag: getters.goodsTag,
          intro: getters.intro,
          mainImage: mainImg,
          subImages: subImg
        },
        serviceCondition: serviceCondition,
        goodsOption: {
          hasOwnDeliveryPrice: false,
          options: options
        },
        usableHour: usableHour,
        b2bChannel: {
          channelSalesAgreement: getters.agreementExternalChannelDist,
          excludedChannels: getters.excludedChannels,
          tablenjoyExcluded: getters.tablenjoyExcluded,
        },
        "usage": {
          "useInfo": getters.usePolicyStr,
          "baseInfo": getters.basicPolicyStr,
          "notes": getters.cautionPolicyStr,
          "returnsAndRefunds": getters.cancellationRefundPolicyStr
        }
      }


      // console.log(params);


      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.update)
      eventBus.$emit('bus-event', true);
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        eventBus.$emit('bus-event', false);
        //
        if (res.data.code == "OK") {
          commit("setSaveSuccess", true)
        } else {
          commit("setSaveError", err)
        }
      }).catch(err => {
        eventBus.$emit('bus-event', false);
        commit("setSaveError", err)
      })
      return true
    }
    ,

    /** ***************************************************************************************************************/
    //등록대기상품 등록요청
    goodsRegister({ commit, getters }, payload) {

      let mainImg = null
      if (getters.mainImage != null) {
        mainImg = {
          "url": getters.mainImage.url,
          "width": getters.mainImage.width,
          "height": getters.mainImage.height
        }
      }

      let displayOrder = 1
      let subImg = null
      if (getters.subImages.length != 0) {
        subImg = []
        getters.subImages.forEach(function (value, index) {
          subImg.push({
            "title": value.title,
            "description": value.description,
            "displayOrder": displayOrder++,
            "images": value.images
          })
        })
      }

      displayOrder = 1
      let options = null
      if (getters.options.length != 0) {
        options = []
        getters.options.forEach(function (value, index) {

          let option = {
            optionName: value.optionName,
            displayOrder: displayOrder++,
            listPrice: Number(value.listPrice.replace(",", "")),
            salePrice: Number(value.salePrice.replace(",", "")),
            deliveryPrice: null,
            inventory: Number(value.inventory),
            // ageGroup": value.ageGroup,
            // headcount": Number(value.headcount),
            currencyCode: value.currencyCode,
            mainOption: value.mainOption

          }

          if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {
            Object.assign(option, { ageGroup: value.ageGroup, headcount: Number(value.headcount) })
          }
          options.push(option)

        })
      }

      let serviceCondition = {
        serviceArea: {
          brands: [{
            brandCode: null,
            storeCodes: getters.storeCodes
          }]
        },
        timeCondition: {
          hasSalesPeriod: getters.hasSalesPeriod,
          saleStartDate: getters.hasSalesPeriod ? moment(getters.saleStartDate).format('YYYY-MM-DD') : null,
          saleEndDate: getters.hasSalesPeriod ? moment(getters.saleEndDate).format('YYYY-MM-DD') : null,
          availableDateSetting: getters.expirationDateSetting,
          availableDayCount: getters.expirationDateSetting == 'SetDayCount' ? getters.validDayCount : null,
          availableFromDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validFromDate).format('YYYY-MM-DD') : null,
          availableToDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validToDate).format('YYYY-MM-DD') : null
        }
      }
      // console.log(getters.validDayCount)
      if (getters.goodsType != "Booking") { //모바일쿠폰/금액권/예약권 상품
        Object.assign(serviceCondition.timeCondition, { itemCancellableDayCount: getters.cancellableTimeValue })
      }

      let hours = []
      let unusableDays = []
      if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {

        getters.hours.forEach(function (value, index) {
          if (value.hour !== null) {
            hours.push(value.hour.substr(1, 2) + ':' + value.minute.substr(1, 2) + ':00')
          }
        })

        getters.unusableDays.forEach(function (value, index) {
          unusableDays.push(value)
        })
      }

      let usableHour = null

      if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {

        usableHour = {
          "dayOfWeekType": getters.dayOfWeekType,
          "monday": getters.monday,
          "tuesday": getters.tuesday,
          "wednesday": getters.wednesday,
          "thursday": getters.thursday,
          "friday": getters.friday,
          "saturday": getters.saturday,
          "sunday": getters.sunday,
          "hours": hours,
          "unusableDays": unusableDays,
        }
      }


      var channelCodesOptions = getters.channelCodesOptions
      var channelCodes = getters.channelCodes

      const excludedChannels = []
      channelCodesOptions.forEach(v => {
        let flag = true
        channelCodes.forEach(vv => {
          if (vv == v.value) {
            flag = false
          }
        })
        if (flag) {
          excludedChannels.push(v.value)
        }
      })
      commit("setExcludedChannels", excludedChannels)


      const params = {
        "registerId": payload.registerId,
        "goodsType": getters.goodsType,
        "introduction": {
          "goodsName": getters.goodsName,
          "goodsTag": getters.goodsTag,
          "intro": getters.intro,
          "mainImage": mainImg,
          "subImages": subImg
        },
        "serviceCondition": serviceCondition,
        "goodsOption": {
          "hasOwnDeliveryPrice": false,
          "options": options
        },
        "usableHour": usableHour,
        "b2bChannel": {
          "channelSalesAgreement": getters.agreementExternalChannelDist,
          "excludedChannels": getters.excludedChannels,
          "tablenjoyExcluded": getters.tablenjoyExcluded,
        },
        "usage": {
          "useInfo": getters.usePolicyStr,
          "baseInfo": getters.basicPolicyStr,
          "notes": getters.cautionPolicyStr,
          "returnsAndRefunds": getters.cancellationRefundPolicyStr
        }
      }
      // console.log(params)

      eventBus.$emit('bus-event', true);
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.request)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        eventBus.$emit('bus-event', false);
        //
        if (res.data.code == "OK") {
          commit("setRegisterReqSuccess", true)
        } else {
          commit("setRegisterError", err)
        }
      })
        .catch(err => {
          eventBus.$emit('bus-event', false);
          commit("setRegisterReqError", err)
        })
    }
    ,

    /** 상품수정 *******************************************************************************************************/
    //상품정보
    goodsUpdateIntro({ commit, getters }, payload) {

      let mainImg = null

      if (getters.mainImage == null) {
        alert("대표이미지를 등록해 주세요.")
        return
      }

      if (getters.subImages.length < 1) {
        alert("대표이미지를 등록해 주세요.")
        return
      }

      // if(getters.intro == '' || getters.intro == null) {
      //   alert("상품설명을 입력해 주세요.")
      //   return
      // }

      mainImg = {
        "url": getters.mainImage.url,
        "width": getters.mainImage.width,
        "height": getters.mainImage.height
      }


      let displayOrder = 1
      let subImg = null
      if (getters.subImages.length != 0) {
        subImg = []
        getters.subImages.forEach(function (value, index) {
          subImg.push({
            "title": value.title,
            "description": value.description,
            "displayOrder": displayOrder++,
            "images": value.images
          })
        })
      }

      const params = {
        "goodsId": payload.registerId,
        "introduction": {
          "goodsName": getters.goodsName,
          "goodsTag": getters.goodsTag,
          "intro": getters.intro,
          "mainImage": mainImg,
          "subImages": subImg
        }
      }


      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.updateIntro)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("저장되었습니다. ")

      })
        .catch(err => {
        })
    },


    //사용조건
    goodsUpdateCondition({ commit, getters }, payload) {

      if (getters.storeCodes.length < 1) {
        alert("이용가능한 매장을 선택해주세요.")
        return
      }


      if (getters.hasSalesPeriod) {
        if (getters.saleStartDate == null || getters.saleEndDate == null) {
          alert("판매기간을 입력해주세요.")
          return
        }
      }

      if (getters.expirationDateSetting == "SetDayCount") {
        if (getters.validDayCount == null || getters.validDayCount == '') {
          alert("유효기간을 입력해주세요.")
          return
        }
      } else {
        if (getters.validFromDate == null || getters.validFromDate == null) {
          alert("유효기간을 입력해주세요.")
          return
        }
      }

      const params = {
        serviceArea: {
          brands: [{
            brandCode: null,
            storeCodes: getters.storeCodes
          }]
        },

        timeCondition: {
          hasSalesPeriod: getters.hasSalesPeriod,
          saleStartDate: getters.hasSalesPeriod ? moment(getters.saleStartDate).format('YYYY-MM-DD') : null,
          saleEndDate: getters.hasSalesPeriod ? moment(getters.saleEndDate).format('YYYY-MM-DD') : null,
          availableDateSetting: getters.expirationDateSetting,
          availableDayCount: getters.expirationDateSetting == 'SetDayCount' ? getters.validDayCount : null,
          availableFromDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validFromDate).format('YYYY-MM-DD') : null,
          availableToDate: getters.expirationDateSetting == 'SetFromToDate' ? moment(getters.validToDate).format('YYYY-MM-DD') : null
        },
        "goodsId": payload.registerId
      }


      if (getters.goodsType != "Booking") { //모바일쿠폰/금액권/예약권 상품

        if (getters.cancellableTimeValue == null) {
          alert("취소기간을 입력해주세요.")
          return
        }
        Object.assign(params.timeCondition, { itemCancellableDayCount: getters.cancellableTimeValue })
      }

      console.log(params);
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.updateCondition)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("저장되었습니다. ")
      })
        .catch(err => {
          alert(err.response.data.message);
        })
    },


    //사용시간,옵션수정(예약,예약권)
    goodsUpdateOptionsAndUsableHours({ commit, getters }, payload) {
      if (getters.dayOfWeekType == null) {
        alert("적용요일을 입력해 주세요.")
        return
      }

      let hours = []
      if (getters.goodsType != "MobileCoupon" && getters.goodsType != "MoneyCoupon") {
        getters.hours.forEach(function (value, index) {
          if (value.hour !== null) {
            hours.push(value.hour.substr(1, 2) + ':' + value.minute.substr(1, 2) + ':00')
          }
        })

        if (hours.length < 1) {
          alert("적용 가능 시간을 입력해 주세요.")
          return
        }

        let unusableDays = getters.unusableDays;

        let displayOrder = 1
        let options = []
        var nameFlag = true
        var priceFlag = true
        var inventoryFlag = true
        var headcntFlag = true
        var ageGroupFlag = true

        getters.options.forEach(function (value, index) {
          if (value.optionName == '') {
            nameFlag = false
          }
          if (value.listPrice == "" || value.salePrice == "") {
            priceFlag = false
          }
          if (value.inventory == "") {
            inventoryFlag = false
          }

          if (getters.goodsType == "Booking" || getters.goodsType == "BookingCoupon") {
            if (value.headcount == '' || value.headcount < 0) {
              headcntFlag = false
            }
            if (value.ageGroup == null) {
              ageGroupFlag = false
            }
          }


          var option = {
            optionName: value.optionName,
            mainOption: value.mainOption,
            displayOrder: displayOrder++,
            listPrice: Number(value.listPrice.replace(",", "")),
            salePrice: Number(value.salePrice.replace(",", "")),
            deliveryPrice: null,
            inventory: Number(value.inventory),
            currencyCode: value.currencyCode,
            updateOptionId: value.newOption ? null : value.optionId,
            newOption: value.newOption,
            ageGroup: value.ageGroup,
            headcount: Number(value.headcount)
          }
          options.push(option)
        })


        if (!nameFlag) {
          alert("옵션명을 정확히 입력해 주세요.")
          return
        }

        if (!priceFlag) {
          alert("가격정보를 정확히 입력해 주세요.")
          return
        }

        if (!inventoryFlag) {
          alert("재고 수량을 정확히 입력해 주세요.")
          return
        }

        if (!ageGroupFlag) {
          alert("권종을 정확히 입력해 주세요.")
          return
        }
        if (!headcntFlag) {
          alert("인원을 정확히 입력해 주세요.")
          return
        }


        let params = {
          goodsId: payload.registerId,
          goodsOption: {
            hasOwnDeliveryPrice: false,
            options: options,
          },
          usableHour: {
            dayOfWeekType: getters.dayOfWeekType,
            monday: getters.monday,
            tuesday: getters.tuesday,
            wednesday: getters.wednesday,
            thursday: getters.thursday,
            friday: getters.friday,
            saturday: getters.saturday,
            sunday: getters.sunday,
            hours: hours,
            unusableDays: unusableDays,
          }
        }

        // console.log(params)
        const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.updateOptionsAndUsableHours)
        axios.post(reqURL, params, {
          headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
        }).then(res => {
          if (res.data.code == "OK") {
            alert("저장되었습니다. ");
            setListOption();
          }
        })
          .catch(err => {
            console.log(err)
          })

        async function setListOption() {
          const reqss = api.changeAPI(payload.siteName, api.basicURL + api.goods.optionsAndUsableHours);
          const params = { goodsId: getters.registerId };
          await axios.get(reqss, {
            params: params,
            headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
          }).then(res => {
            const options = []
            const mainOptionId = res.data.data.goodsOption.mainOptionId
            res.data.data.goodsOption.options.forEach(function (value, index) {
              const option = value
              Object.assign(option, { newOption: false, mainOption: value.optionId == mainOptionId ? true : false })
              options.push(option)
            })
            options.sort(function (a, b) {
              return a.displayOrder < b.displayOrder ? -1 : a.displayOrder < b.displayOrder ? 1 : 0;
            });
            commit('setOptions', options)
            commit('setMainOptionId', res.data.data.goodsOption.mainOptionId)
          })

        }

      }

    },

    //옵션수정(쿠폰,금액권)
    goodsUpdateOptions({ commit, getters }, payload) {
      let displayOrder = 1
      let options = null
      options = []
      var nameFlag = true
      var priceFlag = true
      var inventoryFlag = true

      getters.options.forEach(function (value, index) {

        if (value.optionName == '') {
          nameFlag = false
        }
        if (value.listPrice == "" || value.salePrice == "") {
          priceFlag = false
        }
        if (value.inventory == "") {
          inventoryFlag = false
        }

        var option = {
          optionName: value.optionName,
          mainOption: value.mainOption,
          displayOrder: displayOrder++,
          listPrice: Number(value.listPrice.replace(",", "")),
          salePrice: Number(value.salePrice.replace(",", "")),
          deliveryPrice: null,
          inventory: Number(value.inventory),
          currencyCode: value.currencyCode,
          updateOptionId: value.newOption ? null : value.optionId,
          newOption: value.newOption
        }


        options.push(option)
      })

      if (!nameFlag) {
        alert("옵션명을 정확히 입력해 주세요.")
        return
      }

      if (!priceFlag) {
        alert("가격정보를 정확히 입력해 주세요.")
        return
      }

      if (!inventoryFlag) {
        alert("재고 수량을 정확히 입력해 주세요.")
        return
      }


      const params =
      {
        "hasOwnDeliveryPrice": false,
        "options": options,
        "goodsId": payload.registerId
      }

      // console.log(params)


      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.updateOptions)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("저장되었습니다. ")
      }).catch(err => {
        alert(err.response.data.message);
      })

    },


    //노출정보
    goodsUpdateUsage({ commit, getters }, payload) {
      // console.log("goodsUpdateNotice")

      if (getters.usePolicyStr == null) {
        alert("판매정보를 입력해주세요.")
        return
      }
      if (getters.basicPolicyStr == null) {
        alert("판매정보를 입력해주세요.")
        return
      }
      if (getters.cautionPolicyStr == null) {
        alert("판매정보를 입력해주세요.")
        return
      }
      if (getters.cancellationRefundPolicyStr == null) {
        alert("판매정보를 입력해주세요.")
        return
      }

      const params = {
        "goodsId": payload.registerId,
        "usage": {
          "useInfo": getters.usePolicyStr,
          "baseInfo": getters.basicPolicyStr,
          "notes": getters.cautionPolicyStr,
          "returnsAndRefunds": getters.cancellationRefundPolicyStr
        }
      }
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.updateUsage)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("저장되었습니다. ")
      })
        .catch(err => {
          alert(err.response.data.message);
        })
    }
    ,


    deleteGoods({ commit, getters }, payload) {
      // console.log("deleteGoods")
      const params = {
        "goodsId": payload.registerId,
      }
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.deleteGoods)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("삭제되었습니다. ")
      })
        .catch(err => {
          alert(err.response.data.message);
        })
    }
    ,

    deleteReqGoods({ commit, getters }, payload) {
      const params = {

        "registerId": payload.registerId,
      }
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.deleteReqGoods)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("삭제되었습니다. ")
      })
        .catch(err => {
          alert(err.response.data.message);
        })
    },

    cancelRequestGoods({ commit, getters }, payload) {
      const params = {
        "registerId": payload.registerId,
      }
      const reqURL = api.changeAPI(payload.siteName, api.basicURL + api.goods.cancelRequest)
      axios.post(reqURL, params, {
        headers: { 'Authorization': `Bearer ${payload.currentUser.tokens.access.token}` }
      }).then(res => {
        //
        alert("취소되었습니다. ")
      })
        .catch(err => {
          alert(err.response.data.message);
        })
    },

  }
}
